export const resolveDefaultPageAfterRegistration = defaultPageAfterRegistration =>
  defaultPageAfterRegistration?.indexOf('//') > -1
    ? defaultPageAfterRegistration.split('/').reduce((acc, next, index) => {
        if (index < 3) return acc;
        return `${acc}/${next}`;
      }, '')
    : defaultPageAfterRegistration;
